export const colors = {
    white: '#FFFFFF',
    gray: "#4F585D",
    blue: "#0066FF",
}
